import { AppRoutes } from 'consts/routesPath';
import { useHistory, useLocation } from 'react-router-dom';
import { SecurityConst } from 'consts/data';
import Services from 'services';
import { useDispatch } from 'react-redux';
import types from 'redux/types';
const { REQUEST_API_LOGIN_SUCCESS } = types;

const Security = (props) => {
  const { onAuthRequired } = props;
  const history = useHistory();
  const location = useLocation();
  let authenticated = false;
  const dispatch = useDispatch();

  const skipAuthentication = () => {
    return (
      location.pathname === AppRoutes.Login ||
      location.pathname === AppRoutes.ForgotPassword ||
      location.pathname === AppRoutes.ResetPassword
    );
  };

  try {
    const authStorageStr = localStorage.getItem(SecurityConst.authStorage);

    if (authStorageStr) {
      const authStorage = JSON.parse(authStorageStr);
      if (authStorage?.jwt) {
        authenticated = true;
        dispatch({ type: REQUEST_API_LOGIN_SUCCESS, payload: { sessionId: authStorage?.jwt } });
        Services.attachTokenToHeader(authStorage?.jwt);
      }
    }
  } catch (e) {
    console.log(e.message);
  }

  if (!authenticated && !skipAuthentication()) {
    onAuthRequired && onAuthRequired({ history });
  }

  return props.children;
};

export default Security;
